/** F-45: connection status banner + offline edit freeze notice. */
import type { ConnectionStatus } from "../../core/session.js";

export interface ConnectionBannerProps {
  status: ConnectionStatus;
  frozen: boolean;
  authError: string | null;
}

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  "board-not-found": "This board does not exist.",
  "board-archived": "This board is archived. Restore it from the dashboard to edit.",
  unauthorized: "You are not authorized to open this board.",
  "unknown-document": "Unknown document.",
};

export function ConnectionBanner({ status, frozen, authError }: ConnectionBannerProps) {
  if (authError !== null) {
    return (
      <div className="banner error">
        {AUTH_ERROR_MESSAGES[authError] ?? `Cannot open this board (${authError}).`}
      </div>
    );
  }
  if (frozen) {
    return (
      <div className="banner error">
        Offline for more than 60 seconds — editing is disabled until the connection returns.
      </div>
    );
  }
  if (status !== "connected") {
    return (
      <div className="banner warn">
        {status === "connecting" ? "Connecting…" : "Connection lost — reconnecting…"}
      </div>
    );
  }
  return null;
}
